import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';

import {RequestParameters} from '../../shared/models/request-parameters/parameter.model';
import {GlobalVariable} from '../../global';
import {UserPartner} from './user-partner.model';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class UsersPartnerService {
  private subject = new Subject<any>();
  organizationReference = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getUsersPartners (parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/operators/partner', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getUserPartner (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/partner/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }
  resendPinCode (reference: string) {

    return this.http.put(GlobalVariable.BASE_API_URL + '/operator/partner/' + reference + '/reset-pin', {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }
  resendSecretCode (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/partner/' + reference + '/resend-sms', {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postUserPartner (userPartner: UserPartner) {

    const body = this.normalizeUserPartnerData(userPartner);

    return this.http.post(GlobalVariable.BASE_API_URL + '/operators/partner', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putUserPartner (userPartner: UserPartner) {

    const body = this.normalizeUserPartnerData(userPartner);

    return this.http.put(GlobalVariable.BASE_API_URL + '/operator/partner/' + userPartner.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  patchUserPartner (userPartner: UserPartner) {

    const body = this.normalizeUserPartnerData(userPartner);

    return this.http.patch(GlobalVariable.BASE_API_URL + '/operator/partner/' + userPartner.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteUserPartner (userPartner: UserPartner) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/operator/partner/' + userPartner.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  disableUserPartner(userPartner: UserPartner, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/' + userPartner.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  private normalizeUserPartnerData(userPartner: UserPartner): UserPartner {

    const body = Object.assign({}, userPartner);
    delete body.reference;

    if (body.picture !== null && body.picture !== undefined) {
      body.picture = body.picture.reference;
    }
    if (body.country !== null && body.country !== undefined) {
      body.country = body.country.reference;
    }
    if (body.city !== null && body.city !== undefined) {
      body.city = body.city.reference;
    }
    if (body.organization !== null && body.organization !== undefined) {
      body.organization = body.organization.reference;
    }
    if (body.agency !== null && body.agency !== undefined) {
      body.agency = body.agency.reference;
    }
    if (body.role !== null && body.role !== undefined) {
      body.role = body.role.reference;
    }
    if (body.platform !== null && body.platform !== undefined) {
      body.platform = body.platform.reference;
    }
    return body;
  }
  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  onOrganizationChangeEmit(organizationReference) {
    this.organizationReference.next(organizationReference);
  }
  onOrganizationChangeRecieve() {
    return this.organizationReference.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users-partner/users-partner.service.ts